"use client";

import NextImage, { type ImageLoaderProps, type ImageProps } from "next/image";
import { isTransformationUrl } from "@repo/image-transformations";

function transformationLoader({ src, width, quality }: ImageLoaderProps) {
  const url = new URL(src);
  if (!url.searchParams.has("w") && width) {
    url.searchParams.append("w", width.toString());
  }
  if (!url.searchParams.has("q") && quality) {
    url.searchParams.append("q", quality.toString());
  }
  return url.toString();
}

export type { ImageProps } from "next/image";

export function Image(props: ImageProps) {
  const src = typeof props.src === "string" ? props.src : null;
  if (src && isTransformationUrl(src)) {
    return <NextImage {...props} loader={transformationLoader} />;
  }
  return <NextImage {...props} />;
}

export default Image;
